export const LOGIN_POST = 'LOGIN_POST'
export const LOGIN_UPDATE = 'LOGIN_UPDATE'
export const LOGIN_ERROR = 'LOGIN_ERROR'

export function postLogin(payload = {}) {
  return {
    type: LOGIN_POST,
    payload,
  }
}

export function updateLogin(payload = {}) {
  return {
    type: LOGIN_UPDATE,
    payload,
  }
}

export function errorLogin(payload = {}) {
  return {
    type: LOGIN_ERROR,
    payload,
  }
}
